module.exports = __webpack_public_path__ + "img/匿名.727c72c7.png";